import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OutputWindow, SettingsState, WindowSize } from "./types";

const initialState: SettingsState = {
  ccli: {},
  display: {
    height: 720,
    width: 1280
  },
  outputWindows: []
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    addOutputWindow: (state, action: PayloadAction<OutputWindow>) => {
      state.outputWindows.push(action.payload);
    },
    setCCLILicenseNumber: (state, action: PayloadAction<string>) => {
      state.ccli.licenseNumber = action.payload;
    },
    setCanvasSize: (state, action: PayloadAction<WindowSize>) => {
      state.display.height = action.payload.height;
      state.display.width = action.payload.width;
    },
    setOutputWindows: (state, action: PayloadAction<OutputWindow[]>) => {
      state.outputWindows = [...action.payload];
    }
  }
});

export const settingsActions = settingsSlice.actions;

export default settingsSlice.reducer;
